import script from "./NuevoTurno.vue?vue&type=script&setup=true&lang=js"
export * from "./NuevoTurno.vue?vue&type=script&setup=true&lang=js"

import "./NuevoTurno.vue?vue&type=style&index=0&id=bce2e594&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bce2e594"]])

export default __exports__